<template>
  <div class="index">
    <Header :show-language="true" />
    <Search />
    <div class="product">
      <div class="product-tab">
        <span :class="{ active: tabIndex === 0 }" @click="tabAction(0)">产品</span>
        <span :class="{ active: tabIndex === 1 }" @click="tabAction(1)" v-if="appList.length">应用</span>
        <span :class="{ active: tabIndex === 2 }" @click="tabAction(2)">配方</span>
      </div>
      <div class="product-tabc" v-show="tabIndex === 0">
        <dl :class="{ active: proListKey[index] }" v-for="(item, index) in proList" :key="'pro-item-' + item.banner_id">
          <dt>
            <p>
              <strong @click="searchByLevel(item)">{{ item.classification_name }}</strong>
              <span @click="searchByLevel(item)">{{
                item.classification_english_name
                }}</span>
              <img src="../assets/images/nicon-arrow-down.png" alt="" @click="setProItemVisible(index)" />
            </p>
          </dt>
          <dd v-if="item.children.length > 0">
            <a href="javascript: void" @click="searchByLevel(citem)" v-for="citem in item.children"
              :key="'pro-citem-' + citem.banner_id">
              {{ citem.classification_name }}
            </a>
          </dd>
        </dl>
      </div>
      <div class="product-tabc" v-show="tabIndex === 1">
        <dl :class="{ active: appListKey[index] }" v-for="(item, index) in appList"
          :key="'application-item-' + item.banner_id">
          <dt>
            <p>
              <strong @click="searchByApplicationLevel(item)">{{
                item.classification_name
                }}</strong>
              <span @click="searchByApplicationLevel(item)">{{
                item.classification_english_name
                }}</span>
              <img src="../assets/images/nicon-arrow-down.png" alt="" @click="setApplicationItemVisible(index)" />
            </p>
          </dt>
          <dd v-if="item.children.length > 0">
            <a href="javascript: void" @click="searchByApplicationLevel(citem)" v-for="citem in item.children"
              :key="'application-citem-' + citem.banner_id">
              {{ citem.classification_name }}
            </a>
          </dd>
        </dl>
      </div>
      <div class="product-tabc formula-tabc" v-show="tabIndex === 2">
        <dl v-for="item in FormulaList" :key="item.id">
          <dt>
            <p @click="searchByFormulaCate(item.id, item.name)">
              <strong>{{ item.name }}</strong>
              <span></span>
              <img src="../assets/images/nicon-arrow-down.png" alt="" />
            </p>
          </dt>
        </dl>
      </div>
    </div>
    <div class="recommend-product application-block" v-if="iconApplicationList.length">
      <div class="main-application">
        <h5>APPLICATION SCENARIOS</h5>
        <h4>应用场景</h4>
        <div v-if="iconApplicationList.length === 1">
          <div class="main-application-swiper-item" v-for="(item, index) in iconApplicationList" :key="index">
            <router-link
              :to="`/search/result?type=0&appLevel1=${citem.appLevel1s.join(',')}&appLevel2=${citem.appLevel2s.join(',')}&appLevel3=${citem.appLevel3s.join(',')}&appLevel4=${citem.appLevel4s.join(',')}&appLevel5=${citem.appLevel5s.join(',')}&name=${encodeURIComponent(citem.index_name)}&kwos=${encodeURIComponent(citem.index_name)}`"
              v-for="
citem in item" :key="citem.index_id">
              <span>
                <img :src="citem.index_icon" alt="">
              </span>
              <p>{{ citem.index_name }}</p>
            </router-link>
          </div>
        </div>
        <swiper :options="applicationSwiperOption" class="main-application-swiper" v-else>
          <swiper-slide class="swiper-slide" v-for="(item, index) in iconApplicationList" :key="index">
            <div class="main-application-swiper-item">
              <router-link
                :to="`/search/result?type=0&appLevel1=${citem.appLevel1s.join(',')}&appLevel2=${citem.appLevel2s.join(',')}&appLevel3=${citem.appLevel3s.join(',')}&appLevel4=${citem.appLevel4s.join(',')}&appLevel5=${citem.appLevel5s.join(',')}&name=${encodeURIComponent(citem.index_name)}&kwos=${encodeURIComponent(citem.index_name)}`"
                v-for="
citem in item" :key="citem.index_id">
                <span>
                  <img :src="citem.index_icon" alt="">
                </span>
                <p>{{ citem.index_name }}</p>
              </router-link>
            </div>
          </swiper-slide>
        </swiper>
        <div class="main-application-al" v-if="iconApplicationList.length > 1"></div>
        <div class="main-application-ar" v-if="iconApplicationList.length > 1"></div>
      </div>
    </div>
    <div class="recommend-product">
      <h5>RECOMMENDED PRODUCTS</h5>
      <h4>推荐产品</h4>
      <div class="product-list">
        <a :href="`/#/prodetail?id=${item.details_id}&munufacturer_id=${item.munufacturer_id}`" class="item"
          v-for="item in recommendProList" :key="item.details_id">
          <p class="title">
            <span class="line-box" v-html="item.brand +
              '&nbsp;&nbsp;' +
              item.grade +
              '&nbsp;&nbsp;' +
              item.product_name
              "></span>
          </p>
          <ul class="parameter">
            <li v-html="'CAS：' + item.cas_number" v-if="item.cas_number" class="line-clamp-1"></li>
            <li v-html="'化学式：' + item.molecular_formula" v-if="item.molecular_formula" class="line-clamp-1"></li>
            <li v-html="'化学名称：' + item.chemical_name" v-if="item.chemical_name" class="line-clamp-1"></li>
          </ul>
          <a :href="`/#/companyDetails?companyId=${item.munufacturer_id}`">
            <div class="company">
              <img :src="item.pc_logo" alt="" class="img" />
              <p class="name">{{ item.common_service }}</p>
            </div>
          </a>
        </a>
        <a href="/#/search/result?keyword=&type=0" class="more">
          查看更多
          <img src="../assets/images/more-boxshadow.png" alt="" />
        </a>
      </div>
    </div>

    <div class="experts">
      <h5>INDUSTRY EXPERTS</h5>
      <h4>行业专家</h4>
      <ul>
        <li v-for="item in expertsList" :key="'expert-item-' + item.id">
          <div class="experts-itemt">
            <img :src="item.logoUrl" alt="" @click="gotoExpertHome(item.id)" />
            <strong @click="gotoExpertHome(item.id)">
              {{ item.fullname }}
              <img src="../assets/images/expert-level-icon.png" v-if="item.innovateFlag === 1" />
            </strong>
            <p v-if="item.company || item.companyUrl">
              <span v-if="item.company">{{ item.company }}</span><img :src="item.companyUrl" v-if="item.companyUrl" />
            </p>
            <p>
              <span>职位：{{ item.job }}</span>
            </p>
            <p>
              <span v-if="item.labelName3 || item.labelName2 || item.labelName1">擅长：{{ item.labelName3 ||
                item.labelName2 || item.labelName1 }}</span>
            </p>
          </div>
          <div class="experts-itemb">
            <p>
              <img src="../assets/images/nicon-star.png" alt="" />
              {{ item.avgScoreTotal || 0 }}
            </p>
            <p>
              <img src="../assets/images/nicon-fav.png" alt="" />
              {{ item.allPraiseTotal || 0 }}
            </p>
          </div>
          <img src="../assets/images/experts-shadow.png" alt="" />
        </li>
      </ul>
      <div class="more">
        <a :href="config.MAPI + '/expert/authors'">查看更多</a>
        <img src="../assets/images/more-boxshadow.png" alt="查看更多" />
      </div>
    </div>
    <div class="online" v-if="!isInMiniProgram()">
      <h5>CLASSROOM ONLINE</h5>
      <h4>在线课堂</h4>
      <swiper :options="swiperOption" class="swipers">
        <swiper-slide class="swiper-slide" v-for="(item, index) in onlineList" :key="'classroom' + index">
          <div class="swiper-item" @click="gotoClassroom(item.id, item.type)">
            <img class="online-play" src="../assets/images/nicon-play.png" alt="" />
            <!-- <strong class="online-title">{{item.title}}</strong> -->
            <img :src="(config.ENV === 'production' ? config.CDN : config.API) +
              'courses/downLoadImg?annexId=' +
              item.img5
              " alt="" />
            <div class="online-info">
              <p class="online-fav">
                {{ item.pvCount }}
              </p>
              <div class="online-people">
                <strong>{{ item.lecturer }}</strong>
                <p>{{ item.job }}</p>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <Footer />
  </div>
</template>

<script>
  import header from "./common/header";
  import search from "./common/search";
  import footer from "./common/footer";
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import config from "../common/config";
  import qs from "qs";
  import axios from "axios";
  export default {
    data() {
      return {
        config,
        tabIndex: 0, // 0 产品 1 配方
        proList: [], // 产品列表
        proListKey: [], // 是否展开产品列表
        appList: [],
        appListKey: [],
        FormulaList: [], // 配方列表
        recommendProList: [], // 推荐商品列表
        expertsList: [], // 专家列表
        onlineList: [],
        swiperOption: {
          slidesPerView: 1.2,
        },
        applicationSwiperOption: {
          loop: true,
          navigation: {
            prevEl: '.main-application-al',
            nextEl: '.main-application-ar'
          }
        },
        iconApplicationList: []
      };
    },
    metaInfo: {
      title: "优料库-全球专业的化工原料&材料产品库",
      meta: [
        {
          name: "keywords",
          content: "优料库,配方,原材料,在线课堂,MSDS,TDS,产品手册,免费申请",
        },
        {
          name: "description",
          content:
            "在线支持原料性能搜索,通过覆盖全球供应商的产品数据库资源,为用户提供数据查询、资料下载、在线培训和试样申请等专业信息服务。",
        },
      ],
    },
    mounted() {
      _hmt.push(["_trackPageview", "/"]);
      _hmt.push(["_trackPageview", "/#/"]);
      WeChatShare({
        callback: function () {
          var title = "优料库-全球专业的化工原料&材料产品库",
            desc =
              "在线支持原料性能搜索,通过覆盖全球供应商的产品数据库资源,为用户提供数据查询、资料下载、在线培训和试样申请等专业信息服务。",
            imgUrl = config.PHPHOST + "frontend/web/images/logo-new.jpg";
          wx.onMenuShareAppMessage({
            title: title,
            desc: desc,
            link: window.location.href,
            imgUrl: imgUrl,
          });
          wx.onMenuShareTimeline({
            title: title + " - " + desc,
            link: window.location.href,
            imgUrl: imgUrl,
          });
        },
        data: "jsApiDomain=&url=" + encodeURIComponent(window.location.href),
        url: config.MAPI,
      });

      // 加载产品列表
      this.getProductData();
      // 加载应用分类
      this.getApplicationData();
      // 加载配方列表
      this.getFormulaData();
      // 获取专家列表
      this.getExperts();
      // 获取在线课堂
      this.getClassroom();
      // 获取推荐商品
      this.getRecommendPro();
      // 获取带图标应用分类
      this.getIconApplicationData()
    },
    components: {
      Header: header,
      Search: search,
      Footer: footer,
      swiper,
      swiperSlide,
    },
    methods: {
      isInMiniProgram() {
        const ua = navigator.userAgent.toLowerCase();

        // 微信小程序
        if (ua.match(/micromessenger/i) && ua.match(/miniprogram/i)) {
          return "WeChat MiniProgram";
        }

        // 支付宝小程序
        if (ua.match(/alipayclient/i) && ua.match(/miniprogram/i)) {
          return "Alipay MiniProgram";
        }

        return false;
      },
      /**
       * 显示隐藏产品内容单项内容
       * @param {number} index 索引
       */
      setProItemVisible(index) {
        const temp = [...this.proListKey];
        temp[index] = !temp[index];
        this.proListKey = temp;
      },
      /**
       * 显示隐藏应用内容单项内容
       * @param {number} index 索引
       */
      setApplicationItemVisible(index) {
        const temp = [...this.appListKey];
        temp[index] = !temp[index];
        this.appListKey = temp;
      },
      /**
       * 切换产品&配方
       * @param {number} index 0 产品 1 配方
       */
      tabAction(index) {
        this.tabIndex = index;
      },
      // 获取产品列表数据
      getProductData() {
        axios.post(config.PHPHOST + "api/web/index.php?r=wshop/class-banner").then((r) => {
          if (r.data.error_code === 0) {
            this.proList = r.data.data;
            r.data.data.every((v) => this.proListKey.push(false));
          }
        });
      },
      // 获取应用分类
      getApplicationData() {
        axios
          .post(config.PHPHOST + "/api/web/index.php?r=wshop/application-banner")
          .then((r) => {
            if (r.data.error_code === 0) {
              this.appList = r.data.data;
              r.data.data.every((v) => this.appListKey.push(false));
            }
          });
      },

      // 获取带图标应用分类
      getIconApplicationData() {
        axios
          .post(config.PHPHOST + "/api/web/index.php?r=index/banner-application", qs.stringify({
            len: 1,
            pageSize: 999
          }))
          .then((r) => {
            if (r.data.error_code === 0) {
              const data = r.data.data
              const iconApplicationList = []
              for (let i = 0, l = data.length; i < l; i++) {
                const index = Math.floor(i / 6)
                if (i % 6 === 0) {
                  iconApplicationList[index] = []
                }
                data[i].appLevel1s = []
                data[i].appLevel2s = []
                data[i].appLevel3s = []
                data[i].appLevel4s = []
                data[i].appLevel5s = []
                data[i].product_cate.forEach((v) => {
                  const ids = v.split('-')
                  data[i].appLevel1s.push(ids[0])
                  data[i].appLevel2s.push(ids[1])
                  data[i].appLevel3s.push(ids[2])
                  data[i].appLevel4s.push(ids[3])
                  data[i].appLevel5s.push(ids[4])
                })
                iconApplicationList[index].push(data[i])
              }
              this.iconApplicationList = iconApplicationList
            }
          });
      },
      // 获取配方列表数据
      getFormulaData() {
        axios
          .post(config.PHPHOST + "api/web/index.php?r=second/search/adhibition-type")
          .then((r) => {
            if (r.data.error_code === 0) {
              this.FormulaList = r.data.data;
            }
          });
      },
      // 获取专家列表
      getExperts() {
        axios
          .post(config.PHPHOST + "api/web/index.php?r=second/index/expert-ranking")
          .then((r) => {
            if (r.data.error_code === 0) {
              this.expertsList = r.data.data;
            }
          });
      },
      // 获取在线课堂列表
      getClassroom() {
        axios.get(config.API + "courses/wap/index/banner?page=1&pageSize=4").then((r) => {
          if (r.data.code === 1) {
            this.onlineList = r.data.obj;
          }
        });
      },
      /**
       * 跳转到播放在线课堂
       * @param {number} id
       * @param {number} type
       */
      gotoClassroom(id, type) {
        window.location.href = config.MAPI + "/courses/" + id + "?type=" + type;
      },
      /**
       * 一级分类搜索
       * @param {number} pid 一级分类id
       * @param {string} name 一级分类名称
       */
      searchByLevel1(pid, name) {
        this.$router.push({
          path: "/search/result",
          query: {
            type: 0,
            level1: pid,
            name: name,
          },
        });
      },
      searchByLevel(item) {
        const ids = item.product_cate.split("-");
        this.$router.push({
          path: "/search/result",
          query: {
            type: 0,
            level1: ids[0],
            level2: ids[1],
            level3: ids[2],
            level4: ids[3],
            level5: ids[4],
            name: item.classification_name,
          },
        });
      },
      searchByApplicationLevel(item) {
        const ids = item.product_cate.split("-");
        this.$router.push({
          path: "/search/result",
          query: {
            type: 0,
            appLevel1: ids[0],
            appLevel2: ids[1],
            appLevel3: ids[2],
            appLevel4: ids[3],
            appLevel5: ids[4],
            appName: item.classification_name,
          },
        });
      },
      /**
       * 配方分类
       * @param {number} fid 配方分类
       * @param {string} name 一级分类名称
       */
      searchByFormulaCate(fid, name) {
        this.$router.push({
          path: "/search/result",
          query: {
            type: 1,
            formulacate: fid,
            name: name,
          },
        });
      },
      /**
       * 跳转到专家首页
       * @param {number} id 专家id
       */
      gotoExpertHome(id) {
        window.location.href = id;
      },
      /**
       * [getRecommendPro 获取推荐商品]
       * @return null
       */
      getRecommendPro() {
        axios
          .post(
            `${config.PHPHOST}api/web/index.php?r=product/placed`,
            qs.stringify({
              pageSize: 4,
            })
          )
          .then((r) => {
            r = r.data;
            if (r.error_code === 0) {
              this.recommendProList = r.data;
            }
          });
      },
    },
  };
</script>

<style lang="less" scoped="scoped">
  .index {
    width: 100%;
    height: 100%;
    background: #09154f url("../assets/images/nindex-bg.jpg") no-repeat;
    background-size: 100%;

    .product {
      background-color: #f8f8f8;
      border-top-left-radius: 2rem;
      border-top-right-radius: 2rem;
      position: relative;
      z-index: 1;
      padding: 5rem 2rem 2rem 2rem;
      margin-top: 80%;
      box-shadow: 0 5px 6px rgba(0, 0, 0, 0.1);

      .product-tab {
        width: 60%;
        position: absolute;
        top: -2rem;
        left: 20%;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        border-radius: 1rem;
        overflow: hidden;
        display: flex;

        span {
          width: 33.33%;
          flex: 1;
          height: 4rem;
          line-height: 4rem;
          text-align: center;
          color: #999;
          font-size: 1.4rem;
          letter-spacing: 2px;
          background-color: #fff;

          &.active {
            background-color: #4f67b9;
            color: #fff;
            font-weight: bold;
          }
        }
      }

      .product-tabc {
        dl {
          background-color: #fff;
          box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
          border-radius: 0.8rem;
          overflow: hidden;
          margin-bottom: 2rem;

          &.active {
            dt {
              p {
                img {
                  transform: rotate(180deg);
                }
              }
            }

            dd {
              display: block;
            }
          }

          dt {
            padding: 2rem 0;
            color: #09124f;

            p {
              display: flex;
              align-items: center;
              position: relative;

              &:before {
                content: "";
                position: absolute;
                width: 3px;
                height: 3.6rem;
                background-color: #597eff;
                border-radius: 5px;
              }

              strong {
                display: flex;
                font-weight: bold;
                margin: 0 1rem 0 1.5rem;
                font-size: 1.6rem;
              }

              span {
                flex: 1;
                font-size: 1.4rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                height: 20px;
                line-height: 20px;
              }

              img {
                display: block;
                width: 1.5rem;
                margin-right: 1.5rem;
              }
            }
          }

          dd {
            border-top: 1px solid #eee;
            padding: 1.5rem 2rem;
            display: none;

            a {
              display: inline-block;
              line-height: 2.4rem;
              font-size: 1.2rem;
              color: #999;
              margin-right: 1rem;
              padding: 0.5rem 0;

              &:before {
                content: "";
                display: inline-block;
                vertical-align: middle;
                width: 4px;
                height: 4px;
                background-color: #aaa;
                margin-right: 0.5rem;
                border-radius: 50%;
              }
            }
          }
        }
      }

      .formula-tabc {
        dl {
          dt {
            p {
              img {
                transform: rotate(-90deg);
              }
            }
          }
        }
      }
    }

    .recommend-product {
      position: relative;
      padding: 4rem 2rem 0;
      background: #e6e9f2;
      box-shadow: 0 5px 6px rgba(0, 0, 0, 0.1);

      h5 {
        text-align: center;
        font-weight: 400;
        color: #7e7e7e;
        text-shadow: 1px 1px 1px white;
        font-size: 1.4rem;
      }

      h4 {
        text-align: center;
        color: #7e7e7e;
        font-weight: bold;
        text-shadow: 1px 1px 1px white;
        font-size: 1.6rem;
        margin-top: 0.5rem;
      }

      .product-list {
        display: flex;
        flex-wrap: wrap;
        padding-top: 2.1rem;

        .item {
          flex: 1 1 47.5%;
          width: 47.5%;
          padding: 0.8rem;
          margin-bottom: 3.3rem;
          border-radius: 0.3rem;
          background: #fff;
          overflow: hidden;
          box-sizing: border-box;
          box-shadow: 0 5px 6px rgba(0, 0, 0, 0.1);

          &:nth-of-type(odd) {
            margin-right: 5%;
          }

          .title {
            display: flex;
            align-items: center;
            padding: 0 1rem;
            height: 6.1rem;
            border-radius: 0.4rem;
            background: #eaedf7;
            font-size: 1.4rem;
            line-height: 1.8rem;
            color: #08114e;
            font-weight: 600;

            .line-box {
              display: -webkit-box;
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          }

          .parameter {
            height: 7.4rem;
            padding-top: 1.4rem;
            border-bottom: 0.2rem solid #f5f7f8;

            li {
              padding: 0 0.7rem 1.2rem;
              font-size: 1.2rem;
              color: #5f5f5f;
            }
          }

          .company {
            display: flex;
            padding: 1rem 1.3rem 0.75rem 0.75rem;

            .img {
              width: 3.25rem;
              height: 3.25rem;
              margin-right: 0.8rem;
              border-radius: 0.4rem;
            }

            .name {
              height: 2.8rem;
              font-size: 1.2rem;
              line-height: 1.4rem;
              display: -webkit-box;
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          }
        }

        .more {
          display: block;
          width: 17.4rem;
          height: 3.45rem;
          background-color: #fff;
          text-align: center;
          border-radius: 2rem;
          line-height: 3.45rem;
          margin-bottom: 3.3rem;
          color: #0c2870;
          font-size: 1.3rem;
        }
      }
    }

    .experts {
      background-color: #e6e9f2;
      padding: 3rem 0 1rem 0;

      h5 {
        text-align: center;
        font-weight: 400;
        color: #7c86a6;
        text-shadow: 1px 1px 1px white;
        font-size: 1.4rem;
      }

      h4 {
        text-align: center;
        color: #7c86a6;
        font-weight: bold;
        text-shadow: 1px 1px 1px white;
        font-size: 1.6rem;
        margin-top: 0.5rem;
      }

      ul {
        display: flex;
        flex-wrap: wrap;
        padding: 1rem 0.5rem 0 0.5rem;

        li {
          width: 42%;
          margin: 6rem 4% 0 4%;

          &>img {
            display: block;
            width: 100%;
          }

          .experts-itemt {
            position: relative;
            background-color: #fff;
            border-top-left-radius: 1rem;
            border-top-right-radius: 1rem;
            padding: 5.5rem 0 1.5rem 0;
            text-align: center;
            height: 10.5rem;

            &>img {
              display: block;
              width: 9rem;
              height: 9rem;
              border-radius: 90%;
              border: 3px solid #fff;
              box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
              position: absolute;
              top: 0;
              left: 50%;
              margin: -4.5rem 0 0 -4.5rem;
            }

            strong {
              display: block;
              color: #09124f;
              font-weight: 400;
              font-size: 1.8rem;
              margin-top: 1rem;
              padding-bottom: 0.5rem;

              img {
                width: 1.8rem;
                height: 1.8rem;
                margin-bottom: -0.1rem;
              }
            }

            p {
              font-size: 1.2rem;
              color: #999;
              margin-top: 0.5rem;
              overflow: hidden;
              padding: 0 1rem;
              font-size: 0;

              span {
                display: inline-block;
                font-size: 12px;
                max-width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                height: 2rem;
                line-height: 2rem;
              }

              img {
                display: inline-block;
                width: 2rem;
                height: 2rem;
              }
            }
          }

          .experts-itemb {
            background-color: #989fb6;
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
            display: flex;
            align-items: center;
            padding: 1rem 0;

            p {
              flex: 1;
              text-align: center;
              font-size: 1.4rem;
              font-style: italic;
              color: #fff;
              height: 1.6rem;
              line-height: 1.6rem;
              font-weight: bold;
              display: flex;
              align-items: center;
              justify-content: center;

              &:first-child {
                border-right: 1px solid #fff;
              }

              img {
                width: 1.2rem;
                margin-right: 0.3rem;
              }
            }
          }
        }
      }
    }

    .more {
      width: 17.4rem;
      margin: 2rem auto 0 auto;

      a {
        display: block;
        width: 17.4rem;
        height: 3.45rem;
        background-color: #fff;
        text-align: center;
        border-radius: 2rem;
        line-height: 3.45rem;
        color: #0c2870;
        font-size: 1.3rem;
      }

      img {
        display: block;
        width: 100%;
      }
    }

    .online {
      padding: 3rem 0;
      background-color: #f2f1e6;

      h5 {
        text-align: center;
        font-weight: 400;
        color: #9e9b7e;
        text-shadow: 1px 1px 1px white;
        font-size: 1.4rem;
      }

      h4 {
        text-align: center;
        color: #9e9b7e;
        font-weight: bold;
        text-shadow: 1px 1px 1px white;
        font-size: 1.6rem;
        margin-top: 0.5rem;
      }
    }

    .swiper-slide {
      display: block;
      padding: 2rem 0 0 2rem;
      box-sizing: border-box;

      &:last-child {
        padding: 2rem 2rem 0 2rem;
      }
    }

    .swiper-item {
      position: relative;

      img {
        display: block;
        width: 100%;
        height: 15rem;
        border-radius: 1.2rem;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
      }

      .online-play {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 7rem;
        height: 7rem;
        margin: -7rem 0 0 -3.5rem;
        box-shadow: none;
      }

      .online-title {
        text-align: center;
        color: #fff;
        font-size: 1.6rem;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        width: 100%;
        margin-top: -1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .online-info {
      display: flex;
      align-items: flex-start;
      padding: 2rem 0;

      .online-fav {
        display: flex;
        align-items: center;
        background: #597eff url("../assets/images/nicon-fav.png") no-repeat 2rem center;
        background-size: 1.2rem;
        padding: 0.5rem 2rem 0.5rem 4rem;
        color: #fff;
        border-radius: 3rem;
        font-weight: bold;
        font-style: italic;
      }

      .online-people {
        flex: 1;
        text-align: right;
        color: #333;

        strong {
          font-size: 2rem;
          font-weight: bold;
        }

        p {
          font-size: 1.2rem;
          margin-top: 1rem;
        }
      }
    }
  }

  .application-block {
    padding-bottom: 2rem !important;
  }

  .main-application {
    background-color: #F5F5F5;
    border-radius: 15px;
    box-shadow: 0 0 .5rem rgba(0, 0, 0, .2);
    box-sizing: border-box;
    padding: 4rem 1.5rem 1.5rem;
    position: relative;

    .swiper-slide,
    .swiper-slide[data-v-47323bf2]:last-child {
      padding: 0;
    }

    .main-application-al {
      position: absolute;
      z-index: 1;
      width: 4rem;
      height: 4rem;
      left: .8rem;
      top: 55%;
      background: url('../assets/images/icon-arrow-circle-left.png') no-repeat center/contain;
    }

    .main-application-ar {
      position: absolute;
      z-index: 1;
      width: 4rem;
      height: 4rem;
      right: .8rem;
      top: 55%;
      background: url('../assets/images/icon-arrow-circle-right.png') no-repeat center/contain;
    }

  }

  .main-application-swiper-item {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: .5rem;
    padding-top: 3rem;


    &>a {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 1.4rem;
      padding: 2rem;
      border-radius: 2rem;
      background-color: white;
      text-align: center;
      min-width: 0;

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 4.5rem;
        height: 5rem;
        margin-bottom: .5rem;

        img {
          display: block;
          width: 100%;
        }
      }

      p {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        line-height: 2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue